import { useAuthStore } from '../store/auth-store'

// Re-export Zustand store selectors for DRY
export const useAuth = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const user = useAuthStore((state) => state.user)
  const login = useAuthStore((state) => state.login)
  const logout = useAuthStore((state) => state.logout)
  const hasRole = useAuthStore((state) => state.hasRole)
  const updateLocale = useAuthStore((state) => state.updateLocale)

  return {
    isAuthenticated,
    user,
    login,
    logout,
    hasRole,
    updateLocale,
  }
}
